export default __webpack_public_path__ + "static/media/cancer.f23435f6.png";